import React, { useState } from "react";
import { Box, Typography, TextField, Button, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";

const FormulaireSection = () => {
  const { t } = useTranslation("partenaires/FormulaireSection");

  const [form, setForm] = useState({
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Formulaire :", form);
    alert(t("alerts.sent"));
    setForm({ email: "", phone: "", message: "" });
  };

  return (
    <Box
      id="formulaire"
      sx={{
        maxWidth: "900px",
        mx: "auto",
        px: 2,
        mt: 10,
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      {/* Titre centré */}
      <Typography
        sx={{
          fontWeight: 900,
          fontSize: { xs: "2rem", md: "3rem" },
          color: "#000",
          textAlign: "center",
          mb: 3,
        }}
      >
        {t("title.part1")}{" "}
        <Box component="span" sx={{ color: "#449F2D" }}>
          {t("title.highlight")}
        </Box>
      </Typography>

      {/* Paragraphe centré */}
      <Typography
        sx={{
          fontSize: "1.1rem",
          fontWeight: 400,
          color: "#444",
          textAlign: "center",
          lineHeight: 1.8,
          mb: 5,
          maxWidth: "700px",
          mx: "auto",
        }}
      >
        {t("subtitle")}
      </Typography>

      {/* Formulaire */}
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{ display: "flex", flexDirection: "column", gap: 3 }}
      >
        <TextField
          label={t("fields.email")}
          name="email"
          type="email"
          value={form.email}
          onChange={handleChange}
          fullWidth
        />

        {/* OU entre email et téléphone */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Divider sx={{ flex: 1 }} />
          <Typography variant="body2" sx={{ color: "#888" }}>
            {t("or")}
          </Typography>
          <Divider sx={{ flex: 1 }} />
        </Box>

        <TextField
          label={t("fields.phone")}
          name="phone"
          type="tel"
          value={form.phone}
          onChange={handleChange}
          fullWidth
        />

        <TextField
          label={t("fields.message")}
          name="message"
          value={form.message}
          onChange={handleChange}
          multiline
          rows={5}
          fullWidth
        />

        <Box sx={{ textAlign: "center" }}>
          <Button
            type="submit"
            variant="contained"
            sx={{
              backgroundColor: "#449F2D",
              color: "#fff",
              fontWeight: 600,
              textTransform: "none",
              px: 4,
              py: 1.5,
              fontSize: "1rem",
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "#3A8C27",
                transform: "scale(1.03)",
                transition: "all 0.2s ease-in-out",
              },
            }}
          >
            {t("cta")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default FormulaireSection;